










import {Component} from "vue-property-decorator"
import AbpBase from "../../../lib/abpbase"
import {
	GetDlyChargeStatistics,
	GetVaComplStatistics,
	GetWaterMachine,
	GetWaterMachineCheckStatistics
} from "@/api/report"

@Component
export default class chargeStatistics extends AbpBase{
	loading = false
	dateRange:any = []
	waterMachineItem:any = []
	query:any = {
		MachineCode: '',
		MachineXlh: ''
	}
	data:any = []
	waterMachines:any = []
	selects:Array<any> = []
	materialTypeItem:any = []
	columns:any = [
		{
			title: '水机器ID',
			key: 'waterMachineID',
			align: 'center',
			width: 150
		},
		{
			title: '水机器编号',
			key: 'waterMachinecode',
			align: 'center',
			width: 150
		},
		{
			title: '编号',
			key: 'codeNum',
			align: 'center',
			width: 150
		},
		{
			title: '检查日期',
			key: 'surveyDate',
			align: 'center',
			width: 150
		},
		{
			title: '开机时间',
			key: 'kjTime',
			align: 'center',
			width: 150
		},
		{
			title: '开机者',
			key: 'kjName',
			align: 'center',
			width: 150
		},
		{
			title: '运行情况',
			key: 'yxqk',
			align: 'center',
			width: 150,
			render:(h:any,p:any)=>{
				return h('span', p.row.yxqk === 1 ? '正常' : '异常')
			}
		},
		{
			title: '维修情况',
			key: 'wxqk',
			align: 'center',
			width: 150,
			render:(h:any,p:any)=>{
				return h('span', p.row.wxqk === 1 ? '正常' : '异常')
			}
		},
		{
			title: '原水压',
			key: 'ysy',
			align: 'center',
			width: 150,
		},
		{
			title: '泵后压',
			key: 'bhy',
			align: 'center',
			width: 150,
		},
		{
			title: '前级滤芯',
			key: 'qjlx',
			align: 'center',
			width: 150,
		},
		{
			title: '后级滤芯',
			key: 'hjlv',
			align: 'center',
			width: 150,
		},
		{
			title: '一左级压力',
			key: 'yzjyl',
			align: 'center',
			width: 150,

		},
		{
			title: '一右级压力',
			key: 'yyjyl',
			align: 'center',
			width: 150,
		},
		{
			title: '二左级产水压力',
			key: 'ezjcsyl',
			align: 'center',
			width: 150,
		},
		{
			title: '二右级产水压力',
			key: 'eyjcsyl',
			align: 'center',
			width: 150,
		},
		{
			title: '一进',
			key: 'yj',
			align: 'center',
			width: 150,
		},
		{
			title: '一产',
			key: 'yc',
			align: 'center',
			width: 150,
		},
		{
			title: '二进',
			key: 'ej',
			align: 'center',
			width: 150,
		},
		{
			title: '二产',
			key: 'ec',
			align: 'center',
			width: 150,
		},
		{
			title: '三进',
			key: 'sj',
			align: 'center',
			width: 150,
		},
		{
			title: '三产',
			key: 'sc',
			align: 'center',
			width: 150,
		},
		{
			title: '四进',
			key: 'sij',
			align: 'center',
			width: 150,
		},
		{
			title: '四产',
			key: 'sic',
			align: 'center',
			width: 150,
		},
		{
			title: '一排斥流速',
			key: 'ypcls',
			align: 'center',
			width: 150,
		},
		{
			title: '二排斥流速',
			key: 'epcls',
			align: 'center',
			width: 150,
		},
		{
			title: '三排斥流速',
			key: 'spcls',
			align: 'center',
			width: 150,
		},
		{
			title: '四排斥流速',
			key: 'sipcls',
			align: 'center',
			width: 150,
		},
		{
			title: '盐罐饱和度左',
			key: 'ygbhdz',
			align: 'center',
			width: 150,
			render:(h:any,p:any)=>{
				return h('span', p.row.ygbhdz === 1 ? '饱和' : '异常')
			}
		},
		{
			title: '盐罐饱和度右',
			key: 'ygbhdy',
			align: 'center',
			width: 150,
			render:(h:any,p:any)=>{
				return h('span', p.row.ygbhdz === 1 ? '饱和' : '异常')
			}
		},
		{
			title: '余氯前',
			key: 'ylq',
			align: 'center',
			width: 150
		},
		{
			title: '余氯后',
			key: 'ylh',
			align: 'center',
			width: 150
		},
		{
			title: '沙罐反冲',
			key: 'sgfc',
			align: 'center',
			width: 150,
			render:(h:any,p:any)=>{
				return h('span', p.row.sgfc === 1 ? '饱和' : '异常')
			}
		},
		{
			title: '硬度前',
			key: 'ydq',
			align: 'center',
			width: 150
		},
		{
			title: '硬度后',
			key: 'ydh',
			align: 'center',
			width: 150
		},
		{
			title: '总氯前',
			key: 'zlq',
			align: 'center',
			width: 150
		},
		{
			title: '总氯后',
			key: 'zlh',
			align: 'center',
			width: 150
		},
		{
			title: '碳罐反冲',
			key: 'tgfc',
			align: 'center',
			width: 150,
			render:(h:any,p:any)=>{
				return h('span', p.row.tgfc === 1 ? '是' : '否')
			}
		},
		{
			title: '树脂罐反冲',
			key: 'szgfc',
			align: 'center',
			width: 150,
			render:(h:any,p:any)=>{
				return h('span', p.row.szgfc === 1 ? '是' : '否')
			}
		},
		{
			title: '反渗水产水量',
			key: 'fsscsl',
			align: 'center',
			width: 150
		},
		{
			title: '水质电导度',
			key: 'szddd',
			align: 'center',
			width: 150
		},
		{
			title: '压力范围',
			key: 'ylfw',
			align: 'center',
			width: 150
		},
		{
			title: '操作者',
			key: 'operationName',
			align: 'center',
			width: 150
		},
		{
			title: '核对者',
			key: 'checkName',
			align: 'center',
			width: 150
		},
		{
			title: '消毒记录',
			key: 'xdjl',
			align: 'center',
			width: 150,
			render:(h:any,p:any)=>{
				return h('span', p.row.xdjl === 1 ? '是' : '否')
			}
		},
		{
			title: '更换记录',
			key: 'ghjl',
			align: 'center',
			width: 150,
			render:(h:any,p:any)=>{
				return h('span', p.row.ghjl === 1 ? '是' : '否')
			}
		},
		{
			title: '关机时间',
			key: 'gjTime',
			align: 'center',
			width: 150
		},
		{
			title: '关机者',
			key: 'gjName',
			align: 'center',
			width: 150
		},
		{
			title: '温度',
			key: 'temperature',
			align: 'center',
			width: 150
		},
		{
			title: '湿度',
			key: 'humidity',
			align: 'center',
			width: 150
		},
		{
			title: '备注',
			key: 'note',
			align: 'center',
			width: 150
		}
	]
	async created(){
		this.dateRange = this.getMonthStartAndEnd()
		await this.getSelects()
		this.getData()
	}
	deteChange(e:any){
		this.dateRange = e
		this.getData()
	}
	options = {
		shortcuts: [
			{
				text: '一个月',
				value() {
					const end = new Date();
					const start = new Date();
					end.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
					return [start, end];
				}
			},
			{
				text: '三个月',
				value() {
					const end = new Date();
					const start = new Date();
					end.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
					return [start, end];
				}
			}
		]
	}
	private async getData() {
		this.loading = true
		let query:any = {
			waterMachineItem: [],
			StartDate: this.dateRange[0],
			EndDate: this.dateRange[1]
		}
		this.waterMachineItem.forEach((i:any) => {
			query.waterMachineItem.push(this.waterMachines[i])
		})
		let res = await GetWaterMachineCheckStatistics(query)
		this.data = res.objects
		this.loading = false
	}

	private async getSelects() {
		let res = await GetWaterMachine()
		this.waterMachines = res.objects
		this.waterMachineItem = []
		this.waterMachines.forEach((_:any,index:any) => {
			this.waterMachineItem.push(index)
		})
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/waterCheck/index.vue